import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { FiatCurrency } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetExchangeRates } from "../../api-clients/walletsExchangeRatesClient";

function useExchangeRatesQuery() {
  const query = useQuery({
    queryKey: [QUERY_KEYS.WALLET.EXCHANGE_RATES],
    queryFn: handleGetExchangeRates,
  });

  const getExchangeRate = useCallback(
    (currency: FiatCurrency) => {
      if (!query.data) return;

      const exchangeRates = query.data;
      if (currency === FiatCurrency.NGN) return exchangeRates.ngn;
      return exchangeRates.usd;
    },
    [query.data]
  );

  return {
    query,
    getExchangeRate,
  };
}

export default useExchangeRatesQuery;
